export const ONE_DAY_BOOKING = 1;
